import { forwardRef, useEffect, useState } from "react";
import { Filters as TFilters } from "~/sanity/types-mapped";
import {
  Form,
  SubmitFunction,
  useLocation,
  useNavigate,
} from "@remix-run/react";
import * as Select from "@radix-ui/react-select";
// @ts-ignore
import Check from "@material-design-icons/svg/filled/check.svg?react";
// @ts-ignore
import ChevronDownIcon from "@material-design-icons/svg/filled/keyboard_arrow_down.svg?react";
// @ts-ignore
import ChevronUpIcon from "@material-design-icons/svg/filled/keyboard_arrow_up.svg?react";
import { Button } from "./Button";
import * as styles from "./Dropdown.css";

export type DropdownProps = {
  filter: TFilters[0];
  searchParams?: URLSearchParams;
  submit?: SubmitFunction;
};

export const Dropdown = ({
  filter,
  searchParams,
  submit,
  ...props
}: DropdownProps) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  useEffect(() => {
    searchParams &&
      searchParams.get(filter.slug) == null &&
      setSelectedValue(null);
  }, [searchParams]);

  useEffect(() => {
    setSelectedValue(searchParams?.get(filter.slug) || null);
  }, []);
  const navigate = useNavigate();

  return (
    <div style={{ flexGrow: 1, display: "flex" }}>
      <Select.Root
        name={filter.slug}
        onValueChange={(value) => {
          setSelectedValue(value);
          searchParams
            ? (searchParams.set(filter.slug, value),
              // submit &&
              //   submit(
              //     new URLSearchParams({
              //       [filter.slug]: value,
              //       ...Object.fromEntries(
              //         Array.from(searchParams.entries()).filter(
              //           ([key]) => key !== "page"
              //         )
              //       ),
              //     })
              //   ),
              navigate(
                `?${new URLSearchParams({
                  [filter.slug]: value,
                  ...Object.fromEntries(
                    Array.from(searchParams.entries()).filter(
                      ([key]) => key !== "page"
                    )
                  ),
                })}#archive`
              ))
            : // submit && submit(value);
              navigate(``);
        }}
        value={selectedValue || ""}
        {...props}
      >
        <Select.Trigger
          className={styles.trigger({ isActive: Boolean(selectedValue) })}
        >
          <Select.Value placeholder={`Select ${filter.title}`}></Select.Value>
          <Select.Icon>
            <Button
              asChild
              theme={Boolean(selectedValue) ? "light" : "dark"}
              style={{ pointerEvents: "none" }}
              size="sm"
              isPrimary={false}
              icons={{ iconPrimary: <ChevronDownIcon /> }}
            />
          </Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Content className={styles.content}>
            <Select.Viewport>
              <Select.Group>
                {filter &&
                  Boolean(filter.items.length) &&
                  filter.items.map((option, index) => {
                    return (
                      <SelectItem key={index} value={option.slug || ""}>
                        {option.title}
                      </SelectItem>
                    );
                  })}
              </Select.Group>
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
    </div>
  );
};

type SelectItemProps = {
  children: React.ReactNode;
  value: string;
  disabled?: boolean;
  isSelected?: boolean;
};

const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, value, ...props }, forwardedRef) => {
    return (
      <Select.Item
        {...props}
        ref={forwardedRef}
        value={value}
        className={styles.selectItem}
      >
        <Select.ItemText>{children}</Select.ItemText>
      </Select.Item>
    );
  }
);
